/**
 * Application configuration constants
 */
export const APP_CONFIG = {
  // Timezone configuration
  TIMEZONE: "Europe/Paris",

  // Date formatting
  DATE_FORMAT: "PPP",

  // UI configuration
  BATCH_DELETE_DISPLAY_LIMIT: 3,
} as const;
